import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import ResultComponent from '@Components/Results/result.component';
import Tooltip, { TooltipConstants } from '@Components/Tooltip';
import { InfoTooltipOnClick } from '@Components/InfoTooltip';

// eslint-disable-next-line react/prefer-stateless-function
export default class ResultsListComponent extends React.Component {
  render() {
    const { size, results, gridView } = this.props;
    if (!results.length) return null;

    const { metadata, context, updateItemChecked, searchType, originalSearchType, hideCheckbox } = this.props;

    const containerProps = {
      className: cn(
        'e2e-results-list',
        'rx-list',
        `rx-list--${context}`,
        `${metadata.heatmapMode ? 'rx-list-heatmap' : 'left-gutter right-gutter'}`,
        'rx-list-react'
      ),
      'aria-label': 'Results List',
      role: 'search',
    };
    // eslint-disable-next-line import/no-named-as-default-member
    const tooltipId = Tooltip.TooltipConstants.ids.ResultsListComponent;

    const resultProps = {
      metadata,
      context,
      updateItemChecked,
      searchType,
      originalSearchType,
      gridView,
      hideCheckbox,
      size,
    };

    return (
      <>
        <ul {...containerProps}>
          {results.map((result) => (
            <li className="e2e-results-list-item rx-list-item" key={result.index}>
              <ResultComponent result={result} {...resultProps} />
            </li>
          ))}
        </ul>
        <Tooltip id={TooltipConstants.ids.ResultStructureComponent} />
        <Tooltip id={tooltipId} />
        <InfoTooltipOnClick id={TooltipConstants.ids.ResultFilterComponent} place="right" className="centerArrow" />
      </>
    );
  }
}

ResultsListComponent.defaultProps = {
  updateItemChecked: () => {},
};

ResultsListComponent.propTypes = {
  metadata: MetadataPropTypesShape,
  context: PropTypes.string.isRequired,
  updateItemChecked: PropTypes.func,
  results: PropTypes.array.isRequired,
  size: PropTypes.number.isRequired,
  gridView: PropTypes.bool,
  searchType: PropTypes.string,
  originalSearchType: PropTypes.string,
  hideCheckbox: PropTypes.bool,
};
